import React from 'react';

require('../../../styles/scss/components/extra-questions-widget.scss');

export default class extends React.Component {
  static defaultProps = { questions: [] };
  state = { questions: [] };

  constructor(props) {
    super(props)
    this.state = {
      questions: props.questions.map((question, i) => ({ uiId: i, ...question, active: question.active !== false }))
    }
    this.addBlank = this.addBlank.bind(this)
    this.removeQuestion = this.removeQuestion.bind(this)
    this.toggleActive = this.toggleActive.bind(this)
  }

  addBlank = () => {
    let qs = this.state.questions;
    this.setState({ questions: qs.concat({ id: null, uiId: new Date().getTime(), text: '', type: 'SO', can_change: true, active: true }) });
  };

  removeQuestion = (uiId) => {
    console.log("Remove question", uiId)
    let qs = this.state.questions.slice().filter((qq) => qq.uiId !== uiId);
    this.setState({ questions: qs });
  };

  // answered questions can't be hard-deleted (their answers must be preserved), so this
  // just toggles them out of / back into the form instead of removing them from state
  toggleActive = (uiId) => {
    const qs = this.state.questions.map((q) => q.uiId === uiId ? { ...q, active: !q.active } : q)
    this.setState({ questions: qs });
  };

  render() {
    console.log("Extra questions received:", this.state.questions)
    return (
      <div className="extra-questions-widget">
        {
          this.state.questions.map((q) =>
            <ExtraQuestion removeCb={this.removeQuestion} toggleActiveCb={this.toggleActive} key={q.uiId}
              id={q.id} text={q.text} type={q.type} uiId={q.uiId} answered={q.answered === true}
              active={q.active} can_change={!q.answered} />)
        }
        {
          <div className="form-group">
            <div className="col-xs-12 bottom-buttons">
              <a className="btn btn-success btn-sm add-new-question-button" onClick={this.addBlank}>
                {I18N._('Add a new question')}
                <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
              </a>
            </div>
          </div>
        }
      </div>
    )
  }
}

class ExtraQuestion extends React.Component {
  state = { text: this.props.text || '', type: this.props.type || null, changed: false, can_change: false };

  changeQuestion = (e) => {
    this.setState({ text: e.target.value, changed: true });
  };

  changeType = (e) => {
    this.setState({ type: e.target.value, changed: true });
  };

  render() {
    const hidden = this.props.answered && !this.props.active
    const hiddenTitle = I18N._("Question is currently hidden from the questionnaire, but has received answers before")
    const readOnlyTitle = I18N._("Question can't be edited as it has been answered already")

    return (
      <div className="question">
        <div className="form-group">
          <div className="col-sm-6 col-xs-12">
            <input name="extra_question_ids[]" type="hidden" defaultValue={this.props.id} />
            <input type="hidden" name="extra_question_actives[]" value={this.props.active ? "true" : "false"} />
            <input className={"form-control" + (hidden ? " struck-through" : "")} name="extra_question_texts[]"
              type="text" onChange={this.changeQuestion}
              defaultValue={this.props.text} maxLength="200" readOnly={!this.props.can_change}
              title={hidden ? hiddenTitle : (!this.props.can_change ? readOnlyTitle : undefined)} />
            <span className="help-block">Max. 200 chars</span>
          </div>
          <div className="col-sm-4 col-xs-12">
            <select className={"form-control" + (hidden ? " struck-through" : "")} name="extra_question_types[]"
              onChange={this.changeType}
              defaultValue={this.props.type} disabled={!this.props.can_change}
              title={hidden ? hiddenTitle : (!this.props.can_change ? readOnlyTitle : undefined)}>
              <option value="SC">{I18N._('Fully agree to fully disagree')}</option>
              <option value="FT">{I18N._('Free text')}</option>
            </select>
            {
              /* disabled selects aren't submitted with the form, so mirror the value via a hidden
                 input to keep it (and its position in extra_question_types[]) in the submitted data */
              !this.props.can_change &&
              <input type="hidden" name="extra_question_types[]" value={this.props.type} />
            }
          </div>
          <div className="col-sm-2 col-xs-12">
            <div className="btn-toolbar">
              <div className="btn-group">
                {
                  !this.props.answered && this.props.removeCb &&
                  <a className="btn btn-danger" onClick={() => this.props.removeCb(this.props.uiId)}>
                    <span className="glyphicon glyphicon-trash" aria-hidden="true"></span>
                  </a>
                }
                {
                  this.props.answered && this.props.toggleActiveCb &&
                  <a className={"btn " + (this.props.active ? "btn-danger" : "btn-default")}
                    onClick={() => this.props.toggleActiveCb(this.props.uiId)}
                    title={hidden ? hiddenTitle : undefined}>
                    <span className={"glyphicon " + (this.props.active ? "glyphicon-trash" : "glyphicon-repeat")} aria-hidden="true"></span>
                  </a>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
